// A dwarf tundra shrub: a very low cushion of small dark-green / russet blobs
// hugging the ground. Ported 1:1 from age-of-mcp's classic dwarf-shrub.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#46663a",
      position: [0, 0.12, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.12, 0), color: "#5a6f3e",
      position: [-0.14, 0.1, 0.06] },
    { geometry: new THREE.IcosahedronGeometry(0.11, 0), color: "#7a5e3a",
      position: [0.13, 0.1, -0.05] },
  ];
  return parts;
}

export const dwarfShrub = defineModel({
  id: "dwarf-shrub",
  batchId: "standard",
  name: "Dwarf shrub",
  tags: ["scenery","dwarf","shrub","low-poly","age-of-mcp","classic"],
  summary: "Low-poly dwarf shrub.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => partsFor(),
  animations: [],
});
